import { SPONSORS, PARTNERS, logoCardCls, isDarkLogo } from "@/lib/constants";
import { Heart, ExternalLink, Youtube, Handshake, Instagram } from "lucide-react";

// 4 placeholders — fill the YouTube ids later from the admin/code when new videos are published.
const THANK_VIDEOS = [
  { id: "", title: "Video ringraziamento — in arrivo" },
  { id: "", title: "Highlights stagione — in arrivo" },
  { id: "", title: "Backstage Legend Team — in arrivo" },
  { id: "", title: "Speciale Pubblicità — in arrivo" },
];

export default function ThankSponsors() {
  return (
    <div className="max-w-7xl mx-auto px-4 py-12" data-testid="thank-sponsors-page">
      <div className="text-center max-w-2xl mx-auto mb-10">
        <span className="inline-flex items-center gap-2 font-mono uppercase text-xs tracking-widest text-legend-red mb-3"><Heart size={14} /> Grazie</span>
        <h1 className="font-display font-black uppercase text-4xl md:text-5xl leading-none mb-4">Grazie alla nostra Pubblicità</h1>
        <p className="text-slate-600 dark:text-slate-300">Senza il sostegno dei nostri partner, il Legend Team e Legend Magazine non potrebbero raccontare e vivere il motorsport con questa passione. Un grazie sincero a chi crede in noi.</p>
      </div>

      {/* Big logos */}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5">
        {SPONSORS.map((s) => (
          <a
            key={s.name}
            href={s.url}
            target="_blank"
            rel="noreferrer"
            data-testid={`thanks-sponsor-${s.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            title={s.name}
            className={`group flex flex-col items-center justify-center gap-2 rounded-sm p-6 h-40 hover:border-legend-red hover:shadow-xl transition-all ${logoCardCls(s.name)}`}
          >
            <img src={s.logo} alt={s.name} className="max-h-24 max-w-full object-contain group-hover:scale-105 transition-transform" />
            <span className={`text-[11px] inline-flex items-center gap-1 group-hover:text-legend-red ${isDarkLogo(s.name) ? "text-slate-300" : "text-slate-500"}`}>Visita il sito <ExternalLink size={11} /></span>
          </a>
        ))}
      </div>

      {/* Team partners */}
      <div className="mt-6 grid sm:grid-cols-2 gap-4">
        {PARTNERS.map((p) => (
          <div key={p.name} className="rounded-sm bg-legend-ink text-white flex items-center gap-5 p-6" data-testid={`thanks-partner-${p.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
            <img src={p.logo} alt={p.name} className="h-20 w-20 object-contain rounded-full bg-black shrink-0" />
            <div className="flex-1 min-w-0">
              <span className="inline-flex items-center gap-2 text-legend-yellow font-mono uppercase text-[10px] tracking-widest mb-1"><Handshake size={12} /> Team Partner</span>
              <h3 className="font-display font-black uppercase text-xl leading-tight">{p.name}</h3>
              <p className="text-slate-300 text-xs">{p.tagline}</p>
            </div>
            <a href={p.url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 bg-legend-red hover:bg-legend-dark text-white text-sm font-bold uppercase px-4 py-2 rounded-sm transition-colors shrink-0"><Instagram size={15} /> <span className="hidden sm:inline">Seguili</span></a>
          </div>
        ))}
      </div>

      {/* 4 YouTube slots */}
      <div className="mt-14">
        <div className="flex items-center gap-3 mb-5">
          <span className="h-6 w-1.5 bg-legend-red" />
          <h2 className="font-display font-black uppercase text-2xl md:text-3xl tracking-wide">I nostri video di ringraziamento</h2>
        </div>
        <div className="grid sm:grid-cols-2 gap-5">
          {THANK_VIDEOS.map((v, i) => (
            <div key={i} data-testid={`thanks-video-${i}`} className="rounded-sm overflow-hidden border border-slate-200 dark:border-slate-800 bg-black">
              <div className="relative w-full" style={{ paddingTop: "56.25%" }}>
                {v.id ? (
                  <iframe className="absolute inset-0 w-full h-full" src={`https://www.youtube-nocookie.com/embed/${v.id}`} title={v.title} loading="lazy" allowFullScreen />
                ) : (
                  <div className="absolute inset-0 flex flex-col items-center justify-center gap-2 bg-gradient-to-br from-legend-ink to-slate-900 text-white">
                    <Youtube size={40} className="text-legend-red" />
                    <p className="font-display font-bold uppercase text-sm">Video in arrivo</p>
                    <p className="text-[11px] text-slate-400">Sarà pubblicato al prossimo aggiornamento</p>
                  </div>
                )}
              </div>
              <div className="px-3 py-2 bg-legend-paper text-white text-sm flex items-center gap-2"><Youtube size={15} className="text-legend-red" /> {v.title}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
